module.exports = __webpack_public_path__ + "static/media/6.67ca46c4.jpg";